module.exports = __webpack_public_path__ + "img/pe.9336bb9f.svg";